import React, { Fragment } from 'react';
import ViewContext from 'Context/ViewContext';

const withViewContext = Inner => props => (
  <ViewContext.Consumer>
    {view => (props.requiredView === undefined || props.requiredView === view ? (
      <Inner {...props}>{props.children}</Inner>
    ) : (
      <Fragment />
    ))
    }
  </ViewContext.Consumer>
);

export default withViewContext;
